import * as discoverRoutines from '../../Containers/Discover/discoverRoutines';
import * as ui_actionTypes from './actionTypes';
import * as notificationRoutines from "../../Containers/Notifications/notificationsRoutines";
const initialState = {
    active_discover_id: undefined,
    active_discover_location: undefined,
    active_discover_parent_list: undefined,
    activeChannel: null,

    discoverCardStatus: 'closed',
    activeEvent: null,
    activeNotification: null,
    eventsLoaded: false,
    expandedDiscoverNodes: {},
    sidebar: true,
    sidebarClicked: false,
    resetDocumentsToUpload: false,
    loadingStats:false
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case discoverRoutines.resetDocumentsToUpload.TRIGGER:
            return {
                ...state,
                resetDocumentsToUpload: action.payload,
            };

        case discoverRoutines.clearDiscoverData.TRIGGER:
            return {
                ...state,
                active_discover_id: undefined,
                active_discover_location: undefined,
                active_discover_parent_list: undefined,
            };
        case discoverRoutines.setDiscoverCardStatus.TRIGGER:
            return {
                ...state,
                discoverCardStatus: action.payload,
            };
        case ui_actionTypes.SET_ACTIVE_EVENT:
            return {
                ...state,
                activeEvent: action.event_id,
                sidebar: false,
            };

        case ui_actionTypes.SET_EVENTS_LOADED:
            return {
                ...state,
                eventsLoaded: action.payload,
            };


        case ui_actionTypes.SET_CHANNEL_ACTIVE:
            return {
                ...state,
                activeChannel: action.channel_id,
            };
        case ui_actionTypes.SET_ACTIVE_MOMENT:
            return {
                ...state,
                activeMoment: action.moment_id,
            };
        case ui_actionTypes.SET_ACTIVE_NOTIFICATION:
            return {
                ...state,
                activeNotification: action.notification_id,
            };
        case notificationRoutines.getStatsForPushNotifications.SUCCESS:
            return {
                ...state,
                loadingStats: false
            };
        case notificationRoutines.getStatsForPushNotifications.FAILURE:
            return {
                ...state,
                loadingStats: false
            };
        case ui_actionTypes.SET_CHANNEL_EDITING:
            return {
                ...state,
                activeChannel: action.channel_id,
            };
        case ui_actionTypes.SET_EXPANDED_DISCOVER:
            return {
                ...state,
                expandedDiscoverNodes: {
                    ...state.expandedDiscoverNodes,
                    [action.discover_id]: action.expanded,
                },
            };

        case ui_actionTypes.SET_ACTIVE_DISCOVER:
            return {
                ...state,
                active_discover_id: action.discover_id,
                active_discover_location: action.location,
                active_discover_parent_list: action.parent_list,
                discoverCardStatus: 'open',
            };

        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                sidebar: false,
            };
        case ui_actionTypes.SET_SIDEBAR:
            return {
                ...state,
                sidebar: action.status,
                sidebarClicked: action.clicked ? action.clicked : false,
            };

        default:
            return state;
    }
}
